import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
/**
 * En esta clase se encuentran los servicios relacionados a la consulta,
 * modificación y creación de solicitudes de gestión de vin
 * @author Camilo Delgado
 * @version 2018-10-24
 */
export class SolicitudAutorizacionVinService {

  url : string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public httpClient:HttpClient) {
    this.url = GLOBAL.URL_BASE + 'sicaSolicitudAutorizacionVin';
  }

  /**
   * Consulto todas las solicitudes de autorizacion de vin
   * @author Camilo Delgado
   * @version Oct 24, 2018
   */
  public getDataSicaSolicitudAutorizacionVin(): Observable<any> {
    return this.httpClient.get(this.url + '/getDataSicaSolicitudAutorizacionVin');
  }

  /**
   * Consulto una solicitud de autorizacion de vin por id
   * @author Camilo Delgado
   * @version Oct 24, 2018
   */
  public getSicaSolicitudAutorizacionVin(soavId:number): Observable<any> {
    return this.httpClient.get(this.url + '/getSicaSolicitudAutorizacionVin/' + soavId);
  }

  /**
   * Realizo la aprobación de una solicitud de autorizacion de vin
   * @author Camilo Delgado
   * @version Oct 24, 2018
   */
  public aprobarSolicitud(soavId: number, respuesta:string, usuario:string): Observable<any> {
    return this.httpClient.post(this.url + '/aprobarSolicitud/', {'soavId' : soavId, 'respuesta' : respuesta, 'usuario' : usuario});
  }

  /**
   * Realizo el rechazo de una solicitud de autorizacion de vin
   * @author Camilo Delgado
   * @version Oct 24, 2018
   */
  public rechazarSolicitud(soavId: number, respuesta:string, usuario:string): Observable<any> {
    return this.httpClient.post(this.url + '/rechazarSolicitud/', {'soavId' : soavId, 'respuesta' : respuesta, 'usuario' : usuario});
  }

  /**
   * Realizo la anulación de una solicitud de autorizacion de vin
   * @author Camilo Delgado
   * @version Oct 24, 2018
   */
  public anularSolicitud(soavId: number, usuario:string): Observable<any> {
    return this.httpClient.post(this.url + '/rechazarSolicitud/', {'soavId' : soavId, 'usuario' : usuario});
  }
}
